import styles from './style.module.scss';
import { Col, Table, Row, Divider, Typography, Spin } from 'antd';
import useInvoicesCategoryPieces from '../useInvoicesCategoryPieces';
import BarChangeChart from '../../../charts/barChange';
import UIHelper from '../../../../../helpers/UIHelper';
import PrintFilterText from '../../printFiiterText';

const MainPage = ({
  allReports = false,
  allReportsData,
  isAllReports,
  isMain,
}) => {
  const {
    data,
    columns,
    columns2,
    format,
    title,
    loading,
    summary,
    summary2,
    searchParams,
    filters,
  } = useInvoicesCategoryPieces(true, allReportsData, isAllReports);
  if (!isMain) {
    localStorage.setItem('auth_token', searchParams.get('token'));
  }

  const searchParamsObj = Object.fromEntries([...searchParams]);
  const searchParamsObjKeys = Object.keys(searchParamsObj);
  const availableFilters = filters.filter((i) =>
    searchParamsObjKeys.includes(i.name),
  );

  return (
    <>
      <div className={styles.container}>
        <Spin spinning={loading}>
          {!allReports && (
            <Row className={styles.titleSection} justify={'center'}>
              <Col>
                <Typography.Title level={3}>{title}</Typography.Title>
              </Col>
              <PrintFilterText
                availableFilters={availableFilters}
                searchParams={searchParams}
              />
            </Row>
          )}
          {allReports && (
            <Row className={styles.titleSection} justify={'center'}>
              <Col>
                <Typography.Title level={3}>
                  Sales by Category / Items
                </Typography.Title>
              </Col>
            </Row>
          )}
          <br />
          <Row>
            <Col span={24}>
              <Row>
                <Col span={24}>
                  <Table
                    loading={loading}
                    columns={UIHelper.assignTire(columns)}
                    dataSource={data.table1}
                    pagination={{
                      pageSize: 10000,
                      position: ['bottomCenter'],
                      hideOnSinglePage: true,
                      showSizeChanger: false,
                    }}
                    bordered
                    summary={summary}
                  />
                </Col>
                <Divider />
                <Col span={24}>
                  <Table
                    loading={loading}
                    columns={UIHelper.assignTire(columns2)}
                    dataSource={data.table2}
                    pagination={{
                      pageSize: 10000,
                      position: ['bottomCenter'],
                      hideOnSinglePage: true,
                      showSizeChanger: false,
                    }}
                    bordered
                    summary={summary2}
                  />
                </Col>
              </Row>
            </Col>
            <Col span={14} className={'chartColl'}>
              <BarChangeChart
                keys={['Inc. % Pezzi YTD', 'Inc. % Pezzi LY']}
                data={data}
                format={format}
                itemWidth={150}
              />

              <br />
              <BarChangeChart
                keys={['Inc. % Pezzi YTD', 'Inc. % Pezzi LY']}
                itemWidth={150}
                data={data.bar2}
                format={format}
              />
            </Col>
          </Row>
        </Spin>
      </div>
    </>
  );
};

export default MainPage;
